import { useSelector } from 'react-redux'

export const useLeadSchemeList = () => (
  useSelector(state => state.leadSchemeList || {})
)
